import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ThemeTwoComponent } from './themes/theme-two/theme-two.component';
import { ThemeThreeComponent } from './themes/theme-three/theme-three.component';
import { ThemeFourComponent } from './themes/theme-four/theme-four.component';
import { ThemeFiveComponent } from './themes/theme-five/theme-five.component';
import { ThemeSixComponent } from './themes/theme-six/theme-six.component';
import { ThemeSevenComponent } from './themes/theme-seven/theme-seven.component';
import { ThemeEightComponent } from './themes/theme-eight/theme-eight.component';
import { ThemeNineComponent } from './themes/theme-nine/theme-nine.component';
import { AboutPageComponent } from './components/inner-pages/about-page/about-page.component';
import { PricingPageComponent } from './components/inner-pages/pricing-page/pricing-page.component';
import { ReviewsPageComponent } from './components/inner-pages/reviews-page/reviews-page.component';
import { FaqPageComponent } from './components/inner-pages/faq-page/faq-page.component';
import { DownloadPageComponent } from './components/inner-pages/download-page/download-page.component';
import { ThankYouComponent } from './components/inner-pages/thank-you/thank-you.component';
import { NewsletterPageComponent } from './components/inner-pages/newsletter-page/newsletter-page.component';
import { ErrorOneComponent } from './components/inner-pages/error-page/error-one/error-one.component';
import { ErrorTwoComponent } from './components/inner-pages/error-page/error-two/error-two.component';
import { ContactPageComponent } from './components/inner-pages/contact-page/contact-page.component';
import { MaintenanceComponent } from './components/inner-pages/maintenance/maintenance.component';
import { ComingSoonComponent } from './components/inner-pages/coming-soon/coming-soon.component';
import { BlogTwoColumnComponent } from './components/blogs/blog-two-column/blog-two-column.component';
import { BlogThreeColumnComponent } from './components/blogs/blog-three-column/blog-three-column.component';
import { BlogLeftSidebarComponent } from './components/blogs/blog-left-sidebar/blog-left-sidebar.component';
import { BlogRightSidebarComponent } from './components/blogs/blog-right-sidebar/blog-right-sidebar.component';
import { BlogDetailsLeftSidebarComponent } from './components/blogs/blog-details-left-sidebar/blog-details-left-sidebar.component';
import { BlogDetailsRightSidebarComponent } from './components/blogs/blog-details-right-sidebar/blog-details-right-sidebar.component';
import { HomeComponent } from "./components/home/home.component";
import {CaseStudyFippoaComponent} from "./components/case-study-fippoa/case-study-fippoa.component";
import {CaseStudyZippalComponent} from "./components/case-study-zippal/case-study-zippal.component";
import {CaseStudyNYCDSAComponent} from "./components/case-study-nycdsa/case-study-nycdsa.component";
import {AuthGuardService} from "./guards/auth-guard.service";
import {KaplanIntroComponent} from "./components/kaplan-intro/kaplan-intro.component";
import {
  CaseStudyKaplanReportingComponent
} from "./components/case-study-kaplan-reporting/case-study-kaplan-reporting.component";
import {
  CaseStudyKaplanQuizBuilderComponent
} from "./components/case-study-kaplan-quiz-builder/case-study-kaplan-quiz-builder.component";
import {
  CaseStudyKaplanDesignSystemComponent
} from "./components/case-study-kaplan-design-system/case-study-kaplan-design-system.component";
import {
  CaseStudyKaplanDashboardComponent
} from "./components/case-study-kaplan-dashboard/case-study-kaplan-dashboard.component";


const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'fippoa', component: CaseStudyFippoaComponent},
  {path: 'nycdsa', component: CaseStudyNYCDSAComponent, canActivate: [AuthGuardService]},
  {path: 'zippal', component: CaseStudyZippalComponent},
  {path: 'kaplan-intro', component: KaplanIntroComponent},
  {path: 'kaplan-reporting', component: CaseStudyKaplanReportingComponent},
  {path: 'kaplan-quiz-builder', component: CaseStudyKaplanQuizBuilderComponent},
  {path: 'kaplan-design-system', component: CaseStudyKaplanDesignSystemComponent},
  {path: 'kaplan-dashboard', component: CaseStudyKaplanDashboardComponent},
  {path: 'theme-two', component: ThemeTwoComponent},
  {path: 'theme-three', component: ThemeThreeComponent},
  {path: 'theme-four', component: ThemeFourComponent},
  {path: 'theme-five', component: ThemeFiveComponent},
  {path: 'theme-six', component: ThemeSixComponent},
  {path: 'theme-seven', component: ThemeSevenComponent},
  {path: 'theme-eight', component: ThemeEightComponent},
  {path: 'theme-nine', component: ThemeNineComponent},
  {path: 'about-page', component: AboutPageComponent},
  {path: 'pricing-page', component: PricingPageComponent},
  {path: 'reviews-page', component: ReviewsPageComponent},
  {path: 'faq-page', component: FaqPageComponent},
  {path: 'download-page', component: DownloadPageComponent},
  {path: 'thank-you', component: ThankYouComponent},
  {path: 'newsletter-page', component: NewsletterPageComponent},
  {path: 'error-one', component: ErrorOneComponent},
  {path: 'error-two', component: ErrorTwoComponent},
  {path: 'contact-page', component: ContactPageComponent},
  {path: 'maintenance', component: MaintenanceComponent},
  {path: 'coming-soon', component: ComingSoonComponent},
  {path: 'blog-two-column', component: BlogTwoColumnComponent},
  {path: 'blog-three-column', component: BlogThreeColumnComponent},
  {path: 'blog-left-sidebar', component: BlogLeftSidebarComponent},
  {path: 'blog-right-sidebar', component: BlogRightSidebarComponent},
  {path: 'blog-details-left-sidebar', component: BlogDetailsLeftSidebarComponent},
  {path: 'blog-details-right-sidebar', component: BlogDetailsRightSidebarComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
